const el = document.createElement('div');
const prefixes = ['Webkit', 'Moz', 'O', 'ms'];
const prefixed = {};

function getPrefixed(key) {
  if (prefixed[key]) return prefixed[key];

  if (el.style[key] !== '') {
    const uppercased = key.charAt(0).toUpperCase() + key.slice(1);
    for (const prefix of prefixes) {
      const potentialKey = prefix + uppercased;
      if (el.style[potentialKey] === '') {
        prefixed[key] = potentialKey;
      }
    }
  } else {
    prefixed[key] = key;
  }
  return prefixed[key] || key;
}

function PrefixVisitor(definition) {
  for (const key in definition) {
    definition[getPrefixed(key)] = definition[key];
  }
}

function FlexVisitor(definition) {
  for (const key in definition) {
    if (key === 'display' && definition[key] === 'flex') {
      const prefixedFlex = getPrefixed('flex');
      if (prefixedFlex !== 'flex') {
        for (const prefix of prefixes) {
          if (prefixedFlex.match(new RegExp(prefix))) {
            if (prefix === 'ms') {
              return (definition[key] = '-ms-flexbox');
            } else {
              return (definition[key] = '-' + prefix.toLowerCase() + '-flex');
            }
          }
        }
      }
    }
  }
}

export default function(definition) {
  for (const name in definition) {
    PrefixVisitor(definition[name]);
    FlexVisitor(definition[name]);
  }

  return definition;
}
